import type { Autenticar } from '../../features/auth/model/types';
import { LoginForm } from '../../features/auth/ui/LoginForm';

interface LoginPageProps {
    aoAutenticar: Autenticar;
    indisponivel: boolean;
    aoTentarNovamente: () => void;
}

export function LoginPage({ aoAutenticar, indisponivel, aoTentarNovamente }: LoginPageProps) {
    return (
        <LoginForm
            aoAutenticar={aoAutenticar}
            indisponivel={indisponivel}
            aoTentarNovamente={aoTentarNovamente}
        />
    );
}
